<template>
    <ion-row style="min-height: calc(6rem + 80px);">
        <ion-col
            class="center flex-d-c ion-no-padding p-5"
            :class="{ 'rot-180': isNotLive() }"
        >
            <ion-icon
                icon="assets/icon/logo.svg"
                class="octo-logo coral-light-color"
                :class="{ 'coral-logo': isDev() }"
            />
            <ion-icon icon="assets/icon/logoTitle.svg" class="octo-title mt-1 coral-light-color"/>
        </ion-col>
    </ion-row>
</template>

<script setup lang="ts">
import { IonCol, IonIcon, IonRow } from "@ionic/vue";
import { isDev, isNotLive } from "@/functions/enviroment";
</script>
